import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateResumeForm } from "../../../actions/resumeBuilder";
import BasicInfoForm from "./BasicInfoForm";
import QualificationForm from "./QualificationForm";
import SkillsForm from "./SkillsForm";
import SummaryForm from "./SummaryForm";
import WorkExperienceForm from "./WorkExperienceForm";
import OthersForm from "./OthersForm";
import CertificationForm from "./CertificationForm";
import { Button } from "reactstrap";

const ResumeBuilderForm = ({
  activeSection,
  setActiveSection,
  setActiveTab,
}) => {
  const { profile } = useSelector((state) => state.customer);

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});

  useEffect(() => {
    const additional_fields = profile?.additional_fields
      ? JSON.parse(profile?.additional_fields)
      : {};

    const initial_state = {
      name: profile?.name || "",
      username: profile?.username || "",
      email: profile?.email || "",
      mobile_number: profile?.mobile_number || "",
      details: additional_fields?.details || "",
      languages_known: additional_fields?.languages_known || "",
      location: additional_fields?.location || "",
      designation: additional_fields?.designation || "",
      current_salary_per_month:
        additional_fields?.current_salary_per_month || "",
      expected_salary_per_month:
        additional_fields?.expected_salary_per_month || "",
      skills: additional_fields?.skills || "",
      facebook_url: additional_fields?.facebook_url || "",
      twitter_url: additional_fields?.twitter_url || "",
      linkedin_url: additional_fields?.linkedin_url || "",
      whatsapp_number: additional_fields?.whatsapp_number || "",
      profile_picture: additional_fields?.profile_picture || "",
      resume: additional_fields?.resume || "",
      resume_size: additional_fields?.resume_size || "",
      cover_letter: additional_fields?.cover_letter || "",
      cover_letter_size: additional_fields?.cover_letter_size || "",
      hobbies: additional_fields?.hobbies || "",
      permanent_address: additional_fields?.permanent_address || "",
      present_address: additional_fields?.present_address || "",
      total_work_experience: additional_fields?.total_work_experience || "",
      job_type: additional_fields?.job_type || "",
      state: additional_fields?.state || "",
      same_as_permanent_address:
        additional_fields?.same_as_permanent_address || "",
    };

    setFormData(initial_state);
  }, [profile]);

  const onChangeValue = (e, value) => {
    setFormData({ ...formData, [value]: e.target.value });
  };

  const onInputBlur = () => {
    dispatch(updateResumeForm(formData));
  };

  useEffect(() => {
    dispatch(updateResumeForm(formData));
  }, [dispatch, formData]);

  const formComponents = {
    section1: BasicInfoForm,
    section2: WorkExperienceForm,
    section3: QualificationForm,
    // section4: ProjectsForm,
    section4: CertificationForm,
    section5: SkillsForm,
    section6: SummaryForm,
    section7: OthersForm,
  };

  const lastSection =
    Object.keys(formComponents)[Object.keys(formComponents)?.length - 1];
  const isLastSection = lastSection === activeSection;

  const renderCurrentForm = () => {
    const FormComponent = formComponents[activeSection] || BasicInfoForm;

    return (
      <FormComponent
        formData={formData}
        onChangeValue={onChangeValue}
        onInputBlur={onInputBlur}
        setFormData={setFormData}
      />
    );
  };

  const handleNext = () => {
    try {
      const indexStr = activeSection?.substring(
        activeSection.length - 1,
        activeSection.length
      );
      const index = parseInt(indexStr, 10);

      if (index < Object.keys(formComponents)?.length) {
        setActiveSection(`section${index + 1}`);
      }

      window.scrollTo({ top: 50, behavior: "smooth" });
    } catch (error) {
      console.log("error while clicking next::", error);
    }
  };

  return (
    <div id="profile-form">
      {renderCurrentForm()}

      <div className="text-end mt-2 d-flex justify-content-end gap-2">
        {isLastSection ? (
          <Button color="primary" onClick={() => setActiveTab("3")}>
            <i className="mdi mdi-eye-outline me-2"></i>
            Preview & Download
          </Button>
        ) : (
          <Button color="primary" onClick={handleNext}>
            Go Next <i className="mdi mdi-arrow-right"></i>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ResumeBuilderForm;
